<div class="container-premium">
  <div class="grid align-items-center mb-4">
    <div class="col-12 md:col-6 lg:col-6">
      <button type="button" pButton icon="fa fa-plus" (click)="crear()" *ngIf="menu.agregar"
              class="btn-primary-full"
              label="{{ 'BTN_AGREGAR' | translate}}"></button>
    </div>
    <div class="col-12 md:col-6 lg:col-6 flex justify-content-end">
      <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             (input)="dt.filterGlobal($event.target.value, 'contains')"
             [(ngModel)]="busqueda" (change)="setBusqueda()">
    </div>
  </div>
  <div class="grid">
    <div class="col-12" style="padding: 0">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="productosTroncal" selectionMode="single" dataKey="idProductoTroncal"
               [paginator]="true" [rows]="10" paginatorPosition="bottom"
               styleClass="table-premium tabla-simple-verde">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.codigo}}</td>
            <td>{{row.nombre}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorProducto" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox [ngModel]="!row.indicadorProducto" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <p-inputSwitch [(ngModel)]="row.indicadorHabilitado" [disabled]="true"></p-inputSwitch>
            </td>
            <td class="text-center">
              <img *ngIf="iconosBase64[row.idProductoTroncal]" [src]="iconosBase64[row.idProductoTroncal]"
                   [alt]="row.nombreAdjuntoIcono" style="width: 24px; height: 24px; object-fit: contain;">
              <i *ngIf="!iconosBase64[row.idProductoTroncal]" class="fa fa-image" style="color: #cbd5e1; font-size: 20px;"></i>
            </td>
            <td class="text-center">
              <div class="flex justify-content-center align-items-center gap-2" style="white-space: nowrap;">
                <button type="button" class="btn-action-premium" icon="fa fa-arrow-up" pButton
                        title="{{'BTN_ARRIBA' | translate}}" *ngIf="row.orden > minorden"
                        (click)="cambiarOrden(-1, row)"></button>
                <button type="button" class="btn-action-premium" icon="fa fa-arrow-down" pButton
                        title="{{'BTN_ABAJO' | translate}}" *ngIf="maxorden > row.orden"
                        (click)="cambiarOrden(1, row)"></button>
              </div>
            </td>
            <td class="text-center">
              <div class="flex justify-content-center align-items-center gap-2" style="white-space: nowrap;">
                <button type="button" class="btn-action-premium" icon="fa fa-pencil" pButton
                        title="{{'BTN_EDITAR' | translate}}" *ngIf="menu.editar"
                        (click)="editar(row)"></button>
                <button type="button" class="btn-action-premium" icon="fa fa-eye" pButton
                        title="{{'BTN_VISUALIZAR' | translate}}"
                        (click)="ver(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center py-5">
              <div class="empty-state">
                <i class="fa fa-folder-open-o empty-icon"></i>
                <p class="empty-text">{{ 'MSG_NOHAYREGISTROS' | translate}}</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
